// src/pages/ApplyFreshPassport.jsx
import React from "react";
import FreshPassport from "../component/FreshPassport";
import styled from "styled-components";

const MainCon = styled.div`
  text-align: center;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

  margin-top: 20px;
  color: #e6e6e6;
`;
const ApplyFreshPassport = () => {
  return (
    <>
      <MainCon>
        <h1>Apply for Fresh Passport</h1>
        <p>Fill in the necessary details to apply for a fresh passport.</p>
      </MainCon>
      {/* Form or details for application can go here */}
      <FreshPassport />
    </>
  );
};

export default ApplyFreshPassport;
